
import { PropType, defineComponent, reactive } from 'vue'
import EventDetailHospitalList from '@/components/block/EventDetailHospitalList.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import {
  EventDetailHospitalContent,
  EventDetailHospitalMovie
} from '@/types/EventDetail'

export default defineComponent({
  name: 'EventDetailHospital',
  components: {
    EventDetailHospitalList,
    HeadingLv3
  },
  props: {
    hospitals: {
      type: Array as PropType<EventDetailHospitalContent[]>,
      default: () => [],
      required: true
    },
    isArchived: {
      type: Boolean,
      default: false,
      required: true
    },
    openModal: {
      type: Function as PropType<
        (movies: EventDetailHospitalMovie[], title: string) => void
      >,
      required: true
    }
  },
  setup() {
    const state = reactive({
      hospitalMoreHidden: false
    })

    const handleToggle = (ev: any) => {
      state.hospitalMoreHidden = !state.hospitalMoreHidden

      const target = ev.target

      const next = target.nextElementSibling
      const height = next.firstElementChild.clientHeight + 16

      next.style.height = state.hospitalMoreHidden ? height + 'px' : '0'
    }

    return {
      state,
      handleToggle
    }
  }
})
